import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

class AuthService {
  #_at = firebase.auth();
  #_fr = firebase.firestore();

  async isAuth(callBack: Function) {
    this.#_at.onAuthStateChanged((user) => {
      callBack(user !== null);
    });
  }

  async login(email: string, password: string): Promise<boolean> {

    return this.#_at.signInWithEmailAndPassword(email, password).then(async ({ user })=> {
      if (user === null) {
        return false;
      } else {
        const currentUser = (await this.#_fr.collection("users").doc(user.uid).get());

        if (currentUser.exists) {
          const userData = currentUser.data();
          
          if (userData && ("isAdmin" in userData) && (userData['isAdmin'] === true)) {
            return true;
          } else {
            await this.#_at.signOut();
            return false;
          }
        }
        return false;
      }
    }).catch( error => {
      console.log(error);
      
      return false;
    });
  }
}

export default AuthService;